export default {
  data () {
    return {
      loading: false,
      activeTab: 'all',
      counter: 10
    }
  },
  methods: {
    closeShowNotificationDrawer () {
      this.$store.dispatch('notification/setNotificationDrawer', false)
      this.getAllNotifications()
      this.getUnreadNotifications()
    },
    async getAllNotifications () {
      this.loading = true
      const payload = {
        page: 1,
        size: this.counter || 10 // this was added for test purpose
      }
      this.$store
        .dispatch('notification/getAllNotification', payload)
        .then(() => {
          this.loading = false
        })
        .catch((error) => {
          this.handleErrorResponseNotification(error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    async getUnreadNotifications () {
      this.loading = true
      const payload = {
        page: 1,
        size: this.counter || 10, // this was added for test purpose
        isRead: false
      }
      this.$store
        .dispatch('notification/getUnreadNotification', payload)
        .then(() => {
          this.loading = false
        })
        .catch((error) => {
          this.handleErrorResponseNotification(error)
        })
        .finally(() => {
          this.loading = false
        })
    },
    resetNotificationDetails () {
      this.$router.replace({
        name: 'transactions'
      })
    },
    resetDrawerOpenedByNotification () {
      this.$store.dispatch('notification/setDrawerOpenedByNotification', false)
    }
  },
  computed: {
    showNotificationDrawer () {
      return this.$store.state.notification.hasNotificationDrawerOpen
    },
    notificationDetails () {
      return this.$store.state.notification.allNotifications.items
    },
    unReadNotifications () {
      return this.$store.state.notification.unreadNotifications.items
    },
    unReadNotificationsCount () {
      return this.$store.state.notification.unreadNotifications.page.totalCount
    },
    unreadNotificationCount () {
      return this.$store.state.notification.allNotifications.unreadCount
    },
    filteredNotifications () {
      return this.activeTab === 'all'
        ? this.notificationDetails
        : this.unReadNotifications
    },
    groupedNotifications () {
      const grouped = {}
      this.filteredNotifications.forEach((item) => {
        const date = this.formatDate(item.createdAt)
        // Checks if the date is not already a key in the grouped object. If not, it initializes an empty array for that date.
        if (!grouped[date]) {
          grouped[date] = []
        }
        grouped[date].push(item)
      })

      return grouped
    },
    notificationRouteDetails () {
      return this.$store.state.notification.transactionNotificationRouteDetails
    },
    notificationStatus () {
      return this.$route.params.status
    },
    notificationType () {
      return this.$route.params.type
    },
    isNotificationRoute () {
      return this.notificationID && this.notificationType
    },
    openFromNotification () {
      return this.$store.state.notification.openFromNotification
    },
    notificationID () {
      return this.$route.params.id
    },
    // this update was masde so that currency swap can take  type deposit to fetch the getTransactionById endpoint
    updatedNotificationType () {
      if (this.$route.params.type === this.$transactionType.CURRENCY_SWAP) {
        return this.$transactionType.DEPOSIT
      } else {
        return this.$route.params.type
      }
    },

    // update the status from notification
    updatedNotificationStatus () {
      let status
      if (
        this.$route.params.status === this.$STATUS.PENDING ||
        this.$route.params.status === this.$STATUS.PROCESSING ||
        this.$route.params.status === this.$STATUS.AWAITING_BUSINESS_APPROVAL ||
        this.$route.params.status === this.$STATUS.NEEDS_UPDATE ||
        this.$route.params.status === this.$STATUS.PENDING_REVIEW
      ) {
        status = this.$STATUS.ONGOING
      } else {
        status = this.$STATUS.HISTORY
      }
      return status
    }
  }
}
